"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Form.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Input = function Input(_ref) {
  var className = _ref.className,
      _onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      trimmed = _ref.trimmed,
      type = _ref.type,
      restProps = _objectWithoutProperties(_ref, ["className", "onBlur", "onChange", "trimmed", "type"]);

  return _react.default.createElement("input", _extends({}, restProps, {
    type: type || 'text',
    className: "form-control ".concat(className || ''),
    onChange: onChange,
    onBlur: function onBlur(e) {
      var maybeTrimmedEvent = trimmed ? R.over(R.lensPath(['target', 'value']), R.trim)(e) : e;

      if (trimmed && onChange) {
        onChange(maybeTrimmedEvent);
      }

      if (_onBlur) {
        _onBlur(maybeTrimmedEvent);
      }
    }
  }));
};

Input.propTypes = {
  className: _propTypes.default.string,
  type: _propTypes.default.string,
  trimmed: _propTypes.default.bool
};
var _default = Input;
exports.default = _default;